import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SpotDetailsModalPage } from './spot-details-modal.page';

const routes: Routes = [
  {
    path: '',
    component: SpotDetailsModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SpotDetailsModalPageRoutingModule {}
